import React, { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import axios from "axios";
import { buildApiUrl } from "../../lib/api";
import "./Marquee.css";

const NewsMarquee = () => {
    const [news, setNews] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await axios.get(buildApiUrl("/news/"));
                setNews(response.data);
            } catch (err) {
                // News is non-critical — fail silently
            } finally {
                setLoaded(true);
            }
        };

        fetchNews();
    }, []);

    if (!news.length) return null;

    return (
        <div className="marquee-wrapper">
            <div className="marquee-container">
                <Marquee gradient={false} speed={25} pauseOnHover>
                    {news.map((article, index) => (
                        <a
                            key={index}
                            href={article.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="marquee-link"
                        >
                            {article.headline}
                        </a>
                    ))}
                </Marquee>
            </div>
        </div>
    );
};

export default NewsMarquee;
